import { api } from '../services/api';
import { linkDelSitio } from '../pwa/compartir';
import { dibujarPlacaMes } from './dibujoPlacaMes';
import { PlacaImagen } from './PlacaImagen';
import { disponiblesMes } from './seccionesPlaca';
import { NOMBRE_APP } from '../marca';

/** La placa del mes: podio, reconocimientos, números, destacados y logros. */
export function PlacaMes({ mes, titulo, onCerrar }: { mes: string; titulo: string; onCerrar: () => void }) {
  return (
    <PlacaImagen
      tipo="mes"
      archivo={`placa-${mes}.png`}
      titulo={`${NOMBRE_APP} · ${titulo}`}
      descripcion={`Resumen de ${titulo}`}
      onCerrar={onCerrar}
      cargar={() => api.placaMes(mes)}
      dibujar={(datos, apagadas) => dibujarPlacaMes(datos, linkDelSitio(), apagadas)}
      disponibles={disponiblesMes}
    />
  );
}
